import { Label } from '@creditflowresearch/uilib/Badge/Label';
import Tooltip from '@creditflowresearch/uilib/Tooltip';
import IIndustry from '@/creditflowresearch/domain/vo/IIndustry';
import ISubindustry from '@/creditflowresearch/domain/vo/ISubindustry';

import styles from '@/creditflowresearch/ui/components/bondscreener/bondscreenerTables.module.scss';

interface IIndustryCell {
  industry: IIndustry,
  subindustry: ISubindustry,
}

const IndustryCell = ({
  industry,
  subindustry,
}: IIndustryCell) => {
  if (!industry || !subindustry) {
    return <>-</>;
  }

  const tooltip = `${ industry.name }: ${ subindustry.name }`;

  return (
    <Tooltip placement="bottom" content={ tooltip }>
      <Label
        className={ styles.sectorLabel }
        backgroundColor={ industry.color }
      >
        { industry.abbreviation }
      </Label>
    </Tooltip>
  );
};

export default IndustryCell;
